import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BeheerButton } from '../ui/BeheerButton';
import { useDb } from '../../hooks/useDb';
const BEHEER_LINKS = [{
  to: '/beheer/logboek',
  label: 'Logboek',
  hint: 'wat en waarom'
}, {
  to: '/beheer/huis',
  label: 'Huis',
  hint: 'kamers, camera’s'
}, {
  to: '/beheer/systeem',
  label: 'Systeem',
  hint: 'diensten, tests'
}];
export function BeheerMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const lastLog = useDb(t => t.log[t.log.length - 1]);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('pointerdown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <div ref={ref} className="relative" data-id="element-1244" data-mp="1sx4qz70wy32v">
      <BeheerButton size="wall" onClick={() => setOpen(v => !v)} data-id="element-1245" data-mp="26v2zhvsjz5ag" />
      <AnimatePresence data-id="element-1246" data-mp="21vqdtedf449g">
        {open && <motion.div role="dialog" aria-label="Beheer" initial={{
        opacity: 0,
        y: 6,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 6,
        scale: 0.97
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute bottom-full right-0 z-40 mb-3 w-[440px] origin-bottom-right rounded-3xl border border-white/10 bg-night-900 p-6" data-id="element-1247" data-mp="21wrnpfip6kpl">
            <p className="text-[24px] font-semibold text-ink" data-id="element-1248" data-mp="vf4lddiipt2d">Beheer</p>
            <nav aria-label="Beheer" className="mt-4 flex flex-col gap-2" data-id="element-1249" data-mp="vdbcdrkfmwr7">
              {BEHEER_LINKS.map(l => <Link key={l.to} to={l.to} className="flex h-16 items-center justify-between rounded-2xl bg-white/[0.05] px-5 text-[22px] font-medium text-ink transition-colors duration-150 hover:bg-white/[0.1]" data-id="element-1250" data-mp="2qj2l4pb8xj2k">
                  {l.label}
                  <span className="text-[18px] font-normal text-ink-muted" data-id="element-1251" data-mp="34aqw2p9re1hy">{l.hint}</span>
                </Link>)}
            </nav>
            {lastLog && <p className="mt-4 border-t border-white/[0.07] pt-4 text-[22px] leading-snug text-ink-muted" data-id="element-1252" data-mp="2cj1lfd6pwhoo">
                Laatst in het logboek: <span className="text-ink-soft" data-id="element-1253" data-mp="2gkdczo95jczi">{lastLog.time} · {lastLog.summary}</span>
              </p>}
            <Link to="/spec" className="mt-3 inline-block text-[20px] text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-1254" data-mp="2lkixmkh07z83">
              Spec &amp; Stijl
            </Link>
          </motion.div>}
      </AnimatePresence>
    </div>;
}